var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    [
      _c(
        "ModalFullScreen",
        {
          attrs: {
            size: "md",
            withBgClickEvent: true,
            contentClass: "maxHeightModal",
          },
          on: { close: _vm.closeModal },
          scopedSlots: _vm._u([
            {
              key: "header",
              fn: function () {
                return [
                  _c(
                    "div",
                    {
                      staticClass:
                        "flex justify-between bg-white pr-4 sm:pr-6 pb-3 pl-0",
                    },
                    [
                      _c("h3", { staticClass: "text-lg pt-0.5 font-medium" }, [
                        _vm._v(" Visits "),
                        _c("span", { staticClass: "eventLength" }, [
                          _vm._v("(" + _vm._s(_vm.events?.length) + ")"),
                        ]),
                      ]),
                      _c(
                        "span",
                        {
                          staticClass:
                            "cursor-pointer flex items-center justify-center absolute top-3 right-3.5",
                          on: {
                            click: function ($event) {
                              return _vm.$emit("close")
                            },
                            mouseover: function ($event) {
                              _vm.isHovered = true
                            },
                            mouseout: function ($event) {
                              _vm.isHovered = false
                            },
                          },
                        },
                        [
                          !_vm.isHovered
                            ? _c("CrossIcon", { staticClass: "h-4 w-4" })
                            : _vm._e(),
                          _vm.isHovered
                            ? _c("CrossIconHover", { staticClass: "h-4 w-4" })
                            : _vm._e(),
                        ],
                        1
                      ),
                    ]
                  ),
                ]
              },
              proxy: true,
            },
            {
              key: "content",
              fn: function () {
                return [
                  _c("div", { staticClass: "modal-content" }, [
                    _c(
                      "ul",
                      { staticClass: "eventContainer" },
                      _vm._l(_vm.events, function (event) {
                        return _c(
                          "li",
                          { key: event.title, staticClass: "event-item" },
                          [
                            _c(
                              "div",
                              {
                                staticClass:
                                  "flex flex-row justify-between w-full",
                              },
                              [
                                _c(
                                  "div",
                                  {
                                    staticClass:
                                      "vuecal__event-title mb-4 flex font-normal custom-prefix",
                                    class: event.class,
                                  },
                                  [
                                    event.status === `OPEN`
                                      ? _c("WarningRed", {
                                          staticClass: "w-3 h-3 mr-2",
                                        })
                                      : _vm._e(),
                                    _vm._v(" " + _vm._s(event.status) + " "),
                                  ],
                                  1
                                ),
                                _c(
                                  "div",
                                  {
                                    staticClass:
                                      "flex flex-row gap-1 items-start font-outfit text-base",
                                  },
                                  [
                                    _c("UIButton", {
                                      attrs: {
                                        buttonText: `Notes${
                                          event.notesCount > 0
                                            ? ` (${event.notesCount})`
                                            : ""
                                        }`,
                                        variant: "black",
                                        size: "calendar",
                                      },
                                      on: {
                                        click: function ($event) {
                                          return _vm.handleShow(event)
                                        },
                                      },
                                    }),
                                    event.checkOutStatus === null &&
                                    event.checkInStatus === null &&
                                    event.enable_visit_based_clock_ins &&
                                    event.accepted &&
                                    !event.completed
                                      ? _c("UIButton", {
                                          attrs: {
                                            buttonText: "Clock in",
                                            variant: "outline-black",
                                            size: "calendar",
                                          },
                                          on: {
                                            click: function ($event) {
                                              return _vm.toggleContractorClockInModal(
                                                event,
                                                true
                                              )
                                            },
                                          },
                                        })
                                      : _vm._e(),
                                    event.checkInStatus !== null &&
                                    event.checkOutStatus === null &&
                                    event.enable_visit_based_clock_ins &&
                                    event.accepted &&
                                    !event.completed
                                      ? _c("UIButton", {
                                          attrs: {
                                            buttonText: "Clock out",
                                            variant: "outline-black",
                                            size: "calendar",
                                          },
                                          on: {
                                            click: function ($event) {
                                              return _vm.toggleContractorClockInModal(
                                                event,
                                                true
                                              )
                                            },
                                          },
                                        })
                                      : _vm._e(),
                                    event.checkOutStatus !== null &&
                                    event.checkInStatus !== null
                                      ? _c("UIButton", {
                                          attrs: {
                                            buttonText: "Log hours",
                                            variant: "outline-black",
                                            size: "calendar",
                                          },
                                          on: {
                                            click: function ($event) {
                                              return _vm.openTimeTrackerModal(
                                                event
                                              )
                                            },
                                          },
                                        })
                                      : _vm._e(),
                                  ],
                                  1
                                ),
                              ]
                            ),
                            _c(
                              "div",
                              {
                                staticClass:
                                  "flex flex-col gap-2 vuecal__event-content",
                              },
                              [
                                _c(
                                  "div",
                                  {
                                    staticClass:
                                      "flex flex-row items-center font-outfit text-xs font-normal",
                                  },
                                  [
                                    _c("ProfileGray", {
                                      staticClass: "w-3 h-3",
                                    }),
                                    event.title
                                      ? _c(
                                          "p",
                                          {
                                            staticClass:
                                              "text-notification-blue ml-3 font-normal",
                                          },
                                          [
                                            _c(
                                              "span",
                                              {
                                                staticClass:
                                                  "text-primary-black text-xs font-normal",
                                              },
                                              [_vm._v(" Client Name:")]
                                            ),
                                            _vm._v(
                                              " " + _vm._s(event.title) + " "
                                            ),
                                          ]
                                        )
                                      : _c("p", { staticClass: "ml-3" }, [
                                          _vm._v("n/a"),
                                        ]),
                                  ],
                                  1
                                ),
                                _c("div", [
                                  _c(
                                    "div",
                                    {
                                      staticClass:
                                        "flex flex-row items-center font-outfit text-xs leading-normal text-primary-black",
                                    },
                                    [
                                      _c("ClockIcon", {
                                        staticClass: "w-3 h-3",
                                      }),
                                      _c(
                                        "p",
                                        {
                                          staticClass:
                                            "ml-3 text-xs font-normal",
                                        },
                                        [
                                          _vm._v(
                                            " " +
                                              _vm._s(
                                                _vm
                                                  .$moment(event.start)
                                                  .format("h:mm A")
                                              ) +
                                              " "
                                          ),
                                          event.end
                                            ? _c("span", [_vm._v(" - ")])
                                            : _vm._e(),
                                          _vm._v(
                                            " " +
                                              _vm._s(
                                                _vm
                                                  .$moment(event.end)
                                                  .format("h:mm A")
                                              ) +
                                              " "
                                          ),
                                        ]
                                      ),
                                    ],
                                    1
                                  ),
                                  _c(
                                    "div",
                                    {
                                      staticClass:
                                        "flex flex-row items-top font-outfit text-xs",
                                    },
                                    [
                                      _c("LocationGray", {
                                        staticClass: "w-3 h-3 locationSpacing",
                                      }),
                                      event.location
                                        ? _c(
                                            "p",
                                            {
                                              staticClass:
                                                "ml-3 text-primary-black font-normal",
                                            },
                                            [
                                              _vm._v(
                                                " " +
                                                  _vm._s(event.location) +
                                                  " "
                                              ),
                                            ]
                                          )
                                        : _c("p", { staticClass: "ml-3" }, [
                                            _vm._v("n/a"),
                                          ]),
                                    ],
                                    1
                                  ),
                                  _c(
                                    "div",
                                    {
                                      staticClass:
                                        "flex flex-col items-top font-outfit text-xs mb-3 mt-2 font-normal",
                                    },
                                    [
                                      _c(
                                        "p",
                                        {
                                          staticClass:
                                            "text-brown mb-1 font-normal",
                                        },
                                        [_vm._v("Manager:")]
                                      ),
                                      event.firstName
                                        ? _c(
                                            "div",
                                            {
                                              staticClass:
                                                "flex flex-row gap-2",
                                            },
                                            [
                                              _c(
                                                "div",
                                                {
                                                  staticClass:
                                                    "flex flex-row gap-1",
                                                },
                                                [
                                                  _c(
                                                    "div",
                                                    {
                                                      staticClass:
                                                        "manager-chips flex flex-row items-center text-left",
                                                    },
                                                    [
                                                      _c(
                                                        "div",
                                                        {
                                                          staticClass:
                                                            "rounded-full flex items-center text-xs flex-shrink-0 justify-center text-white capitalize manager-image hover:text-white hover:border-primary-500",
                                                          style: _vm.bgStyle(
                                                            event,
                                                            true
                                                          ),
                                                        },
                                                        [
                                                          _vm._v(
                                                            " " +
                                                              _vm._s(
                                                                _vm.initial(
                                                                  event,
                                                                  true
                                                                )
                                                              ) +
                                                              " "
                                                          ),
                                                        ]
                                                      ),
                                                      _vm._v(
                                                        " " +
                                                          _vm._s(
                                                            event.firstName
                                                          ) +
                                                          " " +
                                                          _vm._s(
                                                            event.familyName
                                                          ) +
                                                          " "
                                                      ),
                                                    ]
                                                  ),
                                                ]
                                              ),
                                              _c(
                                                "button",
                                                {
                                                  on: {
                                                    click: function ($event) {
                                                      return _vm.messageManager(
                                                        event
                                                      )
                                                    },
                                                  },
                                                },
                                                [
                                                  _c("ChatIcon", {
                                                    staticClass: "h-4 w-4",
                                                  }),
                                                ],
                                                1
                                              ),
                                            ]
                                          )
                                        : _c(
                                            "div",
                                            {
                                              staticClass:
                                                "text-xs font-normal",
                                            },
                                            [_vm._v("n/a")]
                                          ),
                                    ]
                                  ),
                                ]),
                              ]
                            ),
                          ]
                        )
                      }),
                      0
                    ),
                  ]),
                ]
              },
              proxy: true,
            },
          ]),
        },
        [
          _vm.timeTrackerModalOpened
            ? _c("TimeTrackerModal", {
                attrs: {
                  name: "time-tracker-modal",
                  currentUserId: _vm.currentUser.id,
                  activity: _vm.selectedEvent.eventObject,
                  tracked_date: _vm.selectedEvent.startDate,
                },
                on: {
                  timesChanged: _vm.handleCloseTimeTrackerModal,
                  close: _vm.handleCloseTimeTrackerModal,
                  openRequestedHoursDeclineReasonModal: (time) => {
                    _vm.declineReasonData = time
                    _vm.timeTrackerModalOpened = false
                    _vm.requestedHoursDeclineReasonModal = true
                  },
                  openDeclineReasonModal: (time) => {
                    _vm.declineReasonData = time
                    _vm.timeTrackerModalOpened = false
                    _vm.showDeclinedReasonConversationModal = true
                  },
                },
              })
            : _vm._e(),
          _vm.showNotesModal
            ? _c("NotesModal", {
                attrs: {
                  name: "notes-modal",
                  currentUser: _vm.currentUser,
                  activity: _vm.selectedEvent.eventObject,
                  project: _vm.selectedEvent.eventObject.project,
                },
                on: { close: _vm.handleClose },
              })
            : _vm._e(),
        ],
        1
      ),
      _vm.isContractorClockInModal
        ? _c("ContractorClockInModal", {
            attrs: {
              name: "clock-in-modal",
              currentUser: _vm.currentUser,
              activity: _vm.selectedEvent.eventObject,
              project: _vm.selectedEvent.eventObject.project,
            },
            on: {
              updateParent: _vm.handleCloseClockIn,
              close: _vm.handleCloseClockIn,
            },
          })
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }